import { API_URL } from "../config/config";
import { patchRequest } from "../utils/axiosUtils";

export const updateFlag = async ({ id, isFooter, type, flagType }) => {
  if (!id || typeof isFooter !== 'boolean' || !type) {
    throw new Error('Missing id, isFooter (boolean), or type for footer update');
  }

  try {
    const payload = {
      id,
      isFooter: Boolean(isFooter),
      type: String(type).toLowerCase(),
      flagType: flagType
    };

    const response = await patchRequest({
      url: `${API_URL}/flag`,
      data: payload,
      headers: { 'Content-Type': 'application/json' },
    });

    if (response?.data?.success === false) {
      const customError = new Error(response.data.message || 'Footer update failed');
      customError.fieldErrors = response.data.errors || {};
      throw customError;
    }

    return response.data;
  } catch (err) {
    const res = err?.response?.data;
    if (res) {
      const customError = new Error(res.message || 'Footer update failed');
      customError.fieldErrors = res.errors || {};
      throw customError;
    }
    throw new Error(err.message || 'Unknown error occurred');
  }
};
